module.exports = __webpack_public_path__ + "static/media/dan.373b894a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/employees/dan.jpg
// module id = 490
// module chunks = 0